import { observable, autorun } from "mobx";
import { Request, MobXHelper, VarHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./Notify.API";

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
};

class NotifyStore {
  @observable listNotify = [];

  getList = async (id, data = {}) => {
    const res = await api.list(id, data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    const json = await res.json();
    this.listNotify = VarHelper.cloneDeep(json.result.list) || [];
  };

  setup = async (id, data) => {
    const res = await api.setup(id, data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  markAllAsRead = async ({userId}) => {
    const res = await api.markAll({userId});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    this.listNotify.map(item => {
      item.read = true; return item;
    });
    return await res.json();
  };

  markOneAsRead = async ({userId, notiId}) => {
    const res = await api.markOne({userId, notiId});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    this.listNotify.map(item => {
      if (item.id === notiId) item.read = true; return item;
    });
    return await res.json();
  };
}

const notifyStore = new NotifyStore();
export default notifyStore;



// WEBPACK FOOTER //
// ./src/services/notify/Notify.Store.js